export const nav_1 = {
  src: 'https://p0.ssl.qhimg.com/t01c5a0591b4212b4ab.jpg',
  alt: '内容1'
}
export const nav_2 = {
  src: 'https://p2.ssl.qhimg.com/t0198f0b7c2e4fdac60.jpg',
  alt: '内容2'
}
